import renderer from 'global/react/renderer';
import JobListings from 'components/react/job-listings/JobListings';

document.addEventListener('DOMContentLoaded', () => {
  renderer({ JobListings });
});
